import { Injectable } from '@angular/core';
import { GenericResponse } from '../business-entities/generic-response';
import { Urls } from '../../../../Autofacets-Core/src/app/utils/urls';
import { DataService } from '../../../../Autofacets-Core/src/app/services/data.service';
import { GearBoxModel, FilterDataModel, CooGroupModel, MaintenanceWorkModel, PartViewModel} from '../business-entities/tecrmi-model';

@Injectable({
    providedIn: 'root'
})

export class TecRMIDataService {
    constructor(private dataProvider: DataService) {
    }

    checkVehicleHasProposal(tecDocType: number) {
        return this.dataProvider.Get<GenericResponse<boolean>>(Urls.VehicleHasProposal, tecDocType).toPromise();
    }
    getGearBoxList(tecDocType: number) {
        return this.dataProvider.Get<GenericResponse<GearBoxModel[]>>(Urls.GetGearBoxList, tecDocType).toPromise();
    }
    checkVehicleHasServiceProposal(tecDocType: number) {
        return this.dataProvider.Get<GenericResponse<boolean>>(Urls.VehicleHasServiceProposal, tecDocType).toPromise();
    }
    getCooGroupList(model : any){
        return this.dataProvider.Post<GenericResponse<CooGroupModel[]>>(Urls.GetCooGroupList, model).toPromise();
    }
    getVehicleMaintenanceWorkList(tecDocType: number){
        return this.dataProvider.Get<GenericResponse<MaintenanceWorkModel>>(Urls.GetVehicleMaitananceWorkList, tecDocType).toPromise();
    }
    getVehicleServiceProposal(model: FilterDataModel){
        return this.dataProvider.Post<GenericResponse<any>>(Urls.GetVehicleServiceProposal, model).toPromise();
    }
    getPartsForWork(tecDocType:number,workStepId : number){
        return this.dataProvider.Get<GenericResponse<PartViewModel[]>>(Urls.GetPartsForWork,tecDocType,workStepId).toPromise();
    }
    updateTecDocIds(lpNumber:any){
        return this.dataProvider.Get<string>(Urls.UpdateTecDocIds,lpNumber).toPromise();
    }
    getAvailableStock(viewmodel:any){
        return this.dataProvider.Post<GenericResponse<any>>(Urls.GetAvailableStock,viewmodel).toPromise();
    }
    createArticlePurchaseOrder(viewmodel:any){
        return this.dataProvider.Post<GenericResponse<any>>(Urls.CreateArticlePurchaseOrder,viewmodel).toPromise();
    }
    getLabourWorkList(tecDocType: number) {
        return this.dataProvider.Get<GenericResponse<any[]>>(Urls.GetLabourWorkList, tecDocType).toPromise();
    }
    getWorkStepsByItemMpId(tecDocType: number,korId: number,itemMpId: number) {
        return this.dataProvider.Get<GenericResponse<any[]>>(Urls.GetWorkStepsByItemMpId, tecDocType,korId,itemMpId).toPromise();
    }
}